
import { Target, ShieldCheck, BarChart3 } from "lucide-react";

export const KeyChallengesSection = () => {
  return (
    <section className="py-16 bg-white" aria-labelledby="challenges-heading">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 id="challenges-heading" className="text-3xl font-bold text-gray-900 mb-4">
            The Security Chaos You're Facing Right Now
          </h2>
          <p className="text-xl text-gray-600">
            We've worked with hundreds of businesses like yours. Here's what we know you're experiencing:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="bg-gradient-to-br from-purple-50 to-white p-8 rounded-xl border border-purple-100 shadow-sm">
            <div className="mb-5 w-14 h-14 rounded-full bg-purple-100 flex items-center justify-center">
              <Target className="h-7 w-7 text-purple-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Regulatory Pressure</h3>
            <p className="text-gray-600">
              "We need to comply with GDPR, CMMC, SOC 2... but we don't know where to start or how to make it manageable without overwhelming our team."
            </p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-white p-8 rounded-xl border border-purple-100 shadow-sm">
            <div className="mb-5 w-14 h-14 rounded-full bg-purple-100 flex items-center justify-center">
              <ShieldCheck className="h-7 w-7 text-purple-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Security Leadership Gap</h3>
            <p className="text-gray-600">
              "We can't afford a full-time CISO, but without security leadership, we're making decisions blindly and our growth initiatives are stalling."
            </p>
          </div>

          <div className="bg-gradient-to-br from-purple-50 to-white p-8 rounded-xl border border-purple-100 shadow-sm">
            <div className="mb-5 w-14 h-14 rounded-full bg-purple-100 flex items-center justify-center">
              <BarChart3 className="h-7 w-7 text-purple-600" />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Lost Business Opportunities</h3>
            <p className="text-gray-600">
              "We're losing deals and partnerships because we can't quickly demonstrate our security posture. Our security uncertainty is directly impacting our bottom line."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
